import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CREATE_CHAUFFEUR_V2, CREATE_CHAUFFEUR_V2_SUCCESS, CREATE_CHAUFFEUR_V2_ERROR } from './../../../actionType.js';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* createChauffeurV2({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/chauffeurs`,
      method: 'POST',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: CREATE_CHAUFFEUR_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CREATE_CHAUFFEUR_V2_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_CHAUFFEUR_V2_ERROR, payload: error });
  }
}

export function* watchcreateChauffeurV2() {
  yield takeEvery(CREATE_CHAUFFEUR_V2, createChauffeurV2);
}

function* createChauffeurV2Saga() {
  yield all([fork(watchcreateChauffeurV2)]);
}

export default createChauffeurV2Saga;
